import { render, staticRenderFns } from "./ChallengesCorrection.vue?vue&type=template&id=36201816&"
import script from "./ChallengesCorrection.vue?vue&type=script&lang=js&"
export * from "./ChallengesCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports